import React from "react";
import { useForm, Controller } from "react-hook-form";
import { Button, CustomInput } from "../../../Components/CustomComponents";
import Fieldset from "../../../Components/FieldSet";
import { Form, InputGroup } from "react-bootstrap";

const PlatformFeeForm = () => {
  const {
    handleSubmit,
    control,
    formState: { errors, isValid },
  } = useForm({
    defaultValues: {
      consumer_platform_fee: "",
      agent_platform_fee: "",
      brokerage_access_fee: "",
    },
  });

  const onSubmit = (data) => {
    console.log(data);
  };

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <h6>Consumer Platform Fee (%)</h6>
      <Controller
        name="consumer_platform_fee"
        control={control}
        rules={{ required: "Consumer Platform Fee is required" }}
        render={({ field }) => (
          <InputGroup className="my-2">
            <CustomInput
              {...field}
              placeholder="Enter Consumer Platform Fee in percentage"
              type="number"
            />
          </InputGroup>
        )}
      />

      <h6>Agent Platform Fee (%)</h6>
      <Controller
        name="agent_platform_fee"
        control={control}
        rules={{ required: "Agent Platform Fee is required" }}
        render={({ field }) => (
          <InputGroup className="my-2">
            <CustomInput
              {...field}
              placeholder="Enter Agent Platform Fee in percentage"
              type="number"
            />
          </InputGroup>
        )}
      />

      <h6>Brokerage Access Fee (%)</h6>
      <Controller
        name="brokerage_access_fee"
        control={control}
        rules={{ required: "Brokerage Access Fee is required" }}
        render={({ field }) => (
          <InputGroup className="my-2">
            <CustomInput
              {...field}
              placeholder="Enter Brokerage Access Fee in $"
              type="number"
            />
          </InputGroup>
        )}
      />

      <Button
        text={"Update"}
        classes={`fs-6 mb-2 mt-auto mt-3 mb-2`}
        type="submit"
      />
    </Form>
  );
};

export default PlatformFeeForm;
